<template>
  <div v-if="visible" class="heatmap-legend">
    <div class="legend-title text-gray-800">{{ title }}</div>
    <div class="legend-bar">
      <div class="gradient-bar" :style="gradientStyle"></div>
      <div class="legend-labels">
        <span>{{ t('messages.transactions.settings.heatmap_low') }}</span>
        <span>{{ t('messages.transactions.settings.heatmap_high') }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { HEATMAP_GRADIENT } from '@/constants'

const props = defineProps({
  visible: Boolean,
  field: String,
})

const { t } = useI18n()

const title = computed(() => t(`messages.transactions.fields.${props.field}`))

const gradientStyle = computed(() => ({
  background: `linear-gradient(to right, ${HEATMAP_GRADIENT.join(', ')})`,
}))
</script>

<style scoped>
  @reference '../../../css/tailwind.css';

.heatmap-legend {
  position: absolute;
  bottom: 40px;
  @apply left-1/2 -translate-x-1/2 rounded-md shadow-md;
  background: white;
  padding: 10px 24px;
  z-index: 1000;
  min-width: 160px;
}
.legend-title {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
}
.gradient-bar {
  height: 12px;
  border-radius: 2px;
}
.legend-labels {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  margin-top: 4px;
  color: #666;
}
</style>
